/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//window vars
window.lang = document.documentElement.lang;

if (document.getElementById('turing')) {
    require('./turing')
}

require('./Typed')

function waitForResources(callback) {
    if (document.readyState === 'complete') {
        // Se il documento è già completamente caricato, esegui il callback immediatamente
        callback();
    } else {
        // Altrimenti, attendi che il caricamento sia completo
        window.addEventListener('load', callback);
    }
}

waitForResources(function () {
    // Aggiungi la classe 'loaded' al body per attivare il fade in
    document.body.classList.add('loaded');

    // Reimposta lo scroll a 0
    window.scrollTo(0, 0);
});


// vimeoooooooooooooo

var players = document.querySelectorAll('.vimeo-player');

players.forEach(function (iframe) {
    var player = new Vimeo.Player(iframe);

    player.ready().then(function () {
        console.log('Player pronto:', iframe.src);

        // Imposta l'opacità a 0 inizialmente
        // iframe.style.opacity = '0';

        player.on('play', function () {
            iframe.classList.add('show');
        });

        // Opzionale: mostra il player dopo un certo tempo se il video non viene avviato
        // setTimeout(function () {
        //     if (iframe.style.opacity === '0') {
        //         iframe.style.opacity = '1';
        //     }
        // }, 5000); // Mostra dopo 3 secondi se non è stato avviato
    });
});
